import { ProductType } from "@/utils/enums/ProductType"
import { useProductsStore } from "@/utils/stores/useProductsStore"

export const useBloodTest = () => {
    const { productsData } = useProductsStore()
    const membership = productsData.membership
    const bloodTestUser = membership && membership.sub_type === ProductType.SubHealth ? true : false
    return { bloodTestUser }
}